import { Command } from "./Command";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { RenderClearFlag } from "../../../../RenderEngine/RenderEnum/RenderClearFlag";
import { Pool } from "../../../../utils/Pool";
export class SetRTCMD extends Command {
    static create(renderTexture, clearColor, clearDepth, clearStencil, backgroundColor, depth = 1, stencil = 0, commandBuffer) {
        let cmd = SetRTCMD._pool.take();
        cmd.renderTexture = renderTexture;
        let clearflag = 0;
        if (clearColor) {
            clearflag |= RenderClearFlag.Color;
            cmd._setRenderTargetCMD.clearColorValue = backgroundColor;
        }
        if (clearDepth) {
            clearflag |= RenderClearFlag.Depth;
            cmd._setRenderTargetCMD.clearDepthValue = depth;
        }
        if (clearStencil) {
            clearflag |= RenderClearFlag.Stencil;
            cmd._setRenderTargetCMD.clearStencilValue = stencil;
        }
        cmd._setRenderTargetCMD.clearFlag = clearflag;
        return cmd;
    }
    get renderTexture() {
        return this._renderTexture;
    }
    set renderTexture(value) {
        this._renderTexture = value;
        this._setRenderTargetCMD.rt = value._renderTarget;
    }
    constructor() {
        super();
        this._renderTexture = null;
        this._setRenderTargetCMD = Laya3DRender.Render3DPassFactory.createSetRenderTargetCMD();
    }
    getRenderCMD() {
        return this._setRenderTargetCMD;
    }
    recover() {
        SetRTCMD._pool.recover(this);
        this._renderTexture = null;
    }
}
SetRTCMD._pool = Pool.createPool(SetRTCMD);
